import { Alert, CircularProgress } from "@mui/material";

import type { VisualizationAssetRecord } from "@/shared/domain/urdf";

import styles from "./ConvertingStep.module.css";

interface ConvertingStepProps {
  /** The status block, or `null` while the request is queued but unstarted. */
  block: VisualizationAssetRecord | null;
  failed: boolean;
}

/**
 * The conversion, while it runs and if it stops.
 *
 * There are three things to distinguish and the status block distinguishes them
 * without a job table: no block at all means the request is queued and the
 * worker has not picked it up; `processing` means it is running; and a terminal
 * status means it is done. Only the failure needs anything of the user, and the
 * retry lives with the dialog's actions rather than here.
 */
export function ConvertingStep({ block, failed }: ConvertingStepProps) {
  if (failed) {
    return (
      <Alert severity="error">
        <p className={styles.errorHeading}>The conversion failed.</p>
        <p className={styles.errorDetail}>
          {block?.error ?? "The worker reported no reason."}
        </p>
      </Alert>
    );
  }

  return (
    <div className={styles.converting} role="status">
      <CircularProgress size="1.5rem" />
      <span>
        {block === null
          ? "Queued — waiting for a worker to pick this up…"
          : "Converting the robot description…"}
      </span>
    </div>
  );
}
